// AI Generated Component
import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '@client/app/services/entities/user/user/user.service';
import { SessionService } from '@monsido/core/session/session.service';
import { LoginService } from '@client/app/core/services/login/login.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { FormUtils } from '@client/ng2/shared/form-utils';
import { safeClone } from '@client/app/shared/utils/object-utils';

@Component({
    selector: 'form-user',
    templateUrl: './user.component.html',
    standalone: false,
})
export class FormUserComponent implements AfterViewInit {
    @Input() user: any = {};
    @Input() monDialogId: string = '';
    @Input() setForm: any;

    @ViewChild('userForm', { static: false }) userForm?: NgForm;

    progress: any;
    onSave = false;

    constructor (
        private userService: UserService,
        private sessionService: SessionService,
        private loginService: LoginService,
        private monDialog: MonDialog,
    ) {}

    ngOnInit () {
        this.activate();
    }

    ngAfterViewInit () {
        if (this.setForm) {
            this.setForm({ id: this.monDialogId, form: this.userForm });
        }
    }

    activate () {
        this.user.customer_admin = this.user.customer_admin || false;
        this.user.send_welcome_email = this.user.send_welcome_email || true;
        if (this.user.id > 0) {
            this.progress = this.userService.get(this.user.id, true).then((result: any) => {
                if (this.user) {
                    if (this.user.id > 0) {
                        this.user = result;
                    }
                }
            }, () => {});
        }
    }

    submit () {
        const user = safeClone(this.user);
        user.domain_users = this.setDomainVisibility('domain_users');
        user.domain_group_members = this.setDomainVisibility('domain_group_members');
        if (Array.isArray(user.labels)) {
            user.labels = user.labels.map((label: any) => {
                return label.id;
            });
        }
        this.onSave = true;
        let promise: any;
        if (user.id === undefined || user.id === null) {
            promise = this.userService.create(user);
        } else {
            promise = this.userService.update(user);
        }

        promise.then(
            (data: any) => {
                if (this.userForm) {
                    FormUtils.markFormAsPristine(this.userForm);
                }
                this.close(data);
                if (data && this.sessionService.me) {
                    if (data.id === this.sessionService.me.id) {
                        this.loginService.loadUser();
                    }
                }
            },
            () => {
                this.onSave = false;
            },
        );
    }

    setDomainVisibility (domainParam: string) {
        return this.user[domainParam].map((domain: any) => {
            domain.visible = this.user.customer_admin || domain.visible;
            domain.send_report = domain.visible && domain.send_report;
            return domain;
        });
    }

    close (user: any) {
        this.monDialog.close(this.monDialogId, user);
    }
}
